import { IconProps } from "./types";

const UserIcon: React.FC<IconProps> = ({ className }) => {
  return <img className={className} src="../../assets/images/kyc.svg" alt="" />;
};

export default UserIcon;
